import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Link,
  LoadingSpinner,
  Switch,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { FeedBase, FeedType, ListingCompact } from '../../../api/gqlaxy/gql/generated/graphql'
import { useGetFeed } from '../../../hooks/gallery/useFeed'
import { defineMessages, useIntl } from 'react-intl'
import { GalleryList } from '../GalleryList/GalleryList'
import { useLocation, useParams } from 'react-router'
import { useSelector } from 'react-redux'
import { RootState } from '../../../types/rootState'
import { selectHomeValue } from '../../../store/selectors/home/metadata'
import { useToggleFeedSubscribed } from '../../../hooks/gallery/useToggleFeedSubscribed'
import { useState } from 'react'
import { GallerySubscribeModal } from '../GallerySubscribeModal/GallerySubscribeModal'
import { hasCustomerToken, isAuthTokenSupported } from '../../../auth'
import { SEARCH_PATH_HELPERS } from '../../../constants/navigation'
import { AssumablesLearnMoreModal } from '../AssumablesLearnMoreModal/AssumablesLearnMoreModal'
import { BuyerPerksLearnMoreModal } from '../BuyerPerksLearnMoreModal/BuyerPerksLearnMoreModal'
import { selectClientId } from '../../../store/selectors/client'
import { selectClientHomes } from '../../../store/selectors/client'
import { Waypoint } from 'react-waypoint'
import { useTrackingDebounceSetters } from '../../../hooks/tracking'
import { useTrackingContext } from '../../../providers/tracking'
import { FOR_YOU } from '../../../constants/tracking/trackingEventConstants'
import { snakeCaseStrings } from '../../../helpers/utils'

export interface FeedProps {
  feed: FeedBase
}

export const Feed = ({ feed }: FeedProps) => {
  const { trackingClient } = useTrackingContext()
  const homes = useSelector(selectClientHomes)
  const homeValue = useSelector<RootState, number>(selectHomeValue)

  const { data, isFetching, refetch } = useGetFeed(
    {
      feedId: feed?.id,
      options: {
        priceAnchor: homeValue ?? undefined
      }
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false
    }
  )
  const params = useParams<{ customerProfileId: string; clientId: string }>()
  const clientId = useSelector(selectClientId)
  const snakeCaseFeedType = snakeCaseStrings(feed.feedType)

  const [trackModuleViewed] = useTrackingDebounceSetters(
    () =>
      trackingClient?.moduleViewed({
        event_source: FOR_YOU,
        module_name: snakeCaseFeedType
      })
  )

  if (isFetching) {
    return (
      <Flex justifyContent='center' mt={5}>
        <LoadingSpinner />
      </Flex>
    )
  }

  return (
    <Box mb={8}>
      <Box mt={5}>
        <Waypoint onEnter={() => trackModuleViewed()} bottomOffset='25%' />
        <GalleryList
          feed={feed}
          data={data}
          refetch={refetch}
          feedType={feed.feedType}
          listings={data?.feed.listings.slice(0, 8) as ListingCompact[]}
          clientId={clientId as string}
        />
      </Box>
    </Box>
  )
}
